module.exports = __webpack_public_path__ + "media/call.977ce575.wav";